/**
 * This is the vanilla function of any of the keypresses.  Use this to detect key presses of anything not provided from our export.
 * You must provide it the keyboard event, as well as an array of event.code or event.key you want to check against.
 *
 * @since v2.33.0
 * @category Keyboard
 * @param {KeyboardEvent} event keyboard event
 * @param {Array<string | number>}keys array of string of keyboard event codes/keyCodes to check against e.g. SPACE_BUTTON = ['Space', ' ', 32]
 * @returns { boolean } true or false whether any of the keys provided have been pressed based on event code or event key. You can provide a keyCode, but it is deprecated and no guarantee it will work.
 * @example
 * // Test whether the the spacebar is pressed
 * keyPressed(event, ['Spacebar', ' ']) //=> true
 * keyPressed(event, ['ArrowUp']) //=> false
 * @docgen_example
 * const event = { key: 'Spacebar' }; //<-- Object from keyboard event
 * keyPressed(event, ['Spacebar']);
*/
export var keyPressed = function (event, keys) { return keys.includes(event.key) || keys.includes(event.code); };
